import React, { useState } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import copy from "copy-to-clipboard";
import {FormattedMessage, useIntl} from "react-intl";
import CopyImage from "../../../static/content/font-awesome/light/copy.svg";
import "../../style/custom/success-purchase.scss";
import {getFormData, setFormData, clearFormData} from "../../components/manager/form";
import {useHistory} from "react-router";
import Footer from "../../components/section/footer";
import StandardTerms from "../../components/standard-terms";
import PrivacyPolicy from "../../components/portal/privacy-policy";

export default function FinalSuccess(props) {
  const history = useHistory();
  const {formatMessage} = useIntl();
  const data = getFormData();
  const {response} = data;
  const [showTerm, setTerm] = useState(false);
  const [showPolicy, setPolicy] = useState(false);

  function handleCopyPassword() {
    const data = getFormData();
    const {response} = data;
    return copy(response.data.newPassword, {
      debug: true,
      message: "Press #{key} to copy",
    });
  }
  
  return (
    <>
      {showTerm && <StandardTerms onClose={() => setTerm(false)} />}
      {showPolicy && <PrivacyPolicy onClose={() => setPolicy(false)} />}
      <div className="success-page-container">
        <div className="success-landing">
          <div className="section-1">
            <Row className="vw-fs">
              <Col xs={12} md={12} className="vw-fs-section">
                <div className="success-modal">
                  <div className="success-modal-heading">
                    <FormattedMessage id={"register.final.congratulations"} />
                  </div>

                  <div className="success-modal-body">
                    <div className="success-purchase-details">
                      <h2><FormattedMessage id={"register.final.success-message"} /></h2>
                    
                      
                      <p>
                        <FormattedMessage id={"register.final.success-message.subtitle"} /><br/>
                        <FormattedMessage id={"register.final.subtext"} />
                      </p>

                      <div className="success-purchase-creds">

                        <div className="order">
                          <span className="vn-label">
                            <FormattedMessage id={"register.final.order-id"} />
                          </span>
                          <span className="vn-value">
                            {String2Hex(response.data.id)}
                          </span>
                        </div>

                        <div className="username">
                          <span className="vn-label">
                            <FormattedMessage id={"register.final.username"} />
                          </span>
                          <span className="vn-value">
                            {response.data.userName}
                          </span>
                        </div>

                        <div className="password">
                          <span className="vn-label">
                            <FormattedMessage id={"register.final.password"} />
                          </span>
                          <span className="vn-value">
                            {response.data.newPassword}
                          </span>
                          <span className="vn-copy">
                            <div
                              className="vw-copyicon"
                              style={{backgroundImage: `url(${CopyImage})`}}
                              onClick={handleCopyPassword}
                            />
                          </span>
                        </div>

                      </div>

                      <div className="success-purchase-actions">
                        <a href="/" target="_blank" className="confirm-proceed">
                          {"Continue"}
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
          <Footer setTerm={setTerm} setPolicy={setPolicy}/>
        </div>
      </div>
    </>
  );
}

function String2Hex(tmp) {
  var str = "";
  for (var i = 0; i < tmp.length; i++) {
    str += tmp[i].charCodeAt(0).toString(16);
  }
  return str;
}

